import React from 'react';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { formatEventDate } from '@root/src/utils/dates';
import getRoute from '@root/src/services/routeList';
import { textH4 } from '@features/ui/styles/textStyles';
import Icon, { ICON_NAME } from '@features/ui/components/Icon';
import { selectEventDetail } from '@features/eventDetail/slices/eventDetailServerSlice';

interface EventLineProps {
  eventId: number;
}

const EventLine = ({ eventId }: EventLineProps) => {
  const event = useSelector(selectEventDetail(eventId));

  return (
    <Link href={getRoute.events(event.slug).description()}>
      <a>
        <EventLineContainer>
          <EventLineCell>
            <p>{event.name}</p>
          </EventLineCell>

          {event.date && (
            <EventLineCell>
              <Icon name={ICON_NAME.dateRange} color="var(--color-white)" />
              {formatEventDate(event.date, event.dateFrom, event.dateTo)}
            </EventLineCell>
          )}

          {event.location && (
            <EventLineCell>
              <Icon name={ICON_NAME.locationOn} color="var(--color-white)" />
              <p>{event.location}</p>
            </EventLineCell>
          )}
        </EventLineContainer>
      </a>
    </Link>
  );
};

export default EventLine;

const EventLineContainer = styled.div`
  display: grid;
  grid-template-columns: 6fr 3fr minmax(0, 3fr);
  gap: 0 10px;

  margin-top: 24px;
  padding: 8px 20px;

  ${textH4}
  color: var(--color-white);
  background: var(--color-grey4);
  border-radius: 8px;

  cursor: pointer;
`;

const EventLineCell = styled.div`
  display: flex;
  gap: 8px;

  > p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
